export default __webpack_public_path__ + "mlp-sworl-left-lg.5d7b14a.png";